import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import BillingModal from './BillingModal'; // Adjust the path as needed
import TableManagementModal from './TableManagementModal';
import ItemTransferModal  from './ItemTransferModal';



const OrderingPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [waiters, setWaiters] = useState([]);
  const [cashiers, setCashiers] = useState([]);
  //const [tableNumber, setTableNumber] = useState('');
  const [tableNumber, setTableNumber] = useState('');

  const [transactionType, setTransactionType] = useState('');
  const [products, setProducts] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [waiter, setWaiter] = useState('');
  const [waiterPin, setWaiterPin] = useState(''); // Add state for waiter PIN
  const [isPinVerified, setIsPinVerified] = useState(false); // Add state for PIN verification
  const [openOrders, setOpenOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [transactionNumber, setTransactionNumber] = useState('');
  const [openTables, setOpenTables] = useState([]);
  
  const [newItems, setNewItems] = useState([]); 

  const [updatedItems, setUpdatedItems] = useState([]);  
  const [productsToDisplay, setProductsToDisplay] = useState(products);
  const [notes, setNotes] = useState(''); 

  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);

  //tables
  const [tables, setTables] = useState([]);

  //for billout
  const [isModalOpen, setModalOpen] = useState(false);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false); // Ensure this starts as false
  
  const [originalCartItems, setOriginalCartItems] = useState([]);
  const originalCartItemsRef = useRef([]);


  //for transfer

  const [showItemTransferModal, setShowItemTransferModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSourceCartId, setSelectedSourceCartId] = useState(null);



  const handleProductTransfer = (sourceCartId, productId) => {
    setSelectedProduct(productId);
    setSelectedSourceCartId(sourceCartId);
    setShowItemTransferModal(true);
  };


  const handleCloseProductTransfer = () => {
    setShowItemTransferModal(false);
    handleRefresh(); // Refresh orders when modal closes
  };

  

  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5001';

  const [order, setOrder] = useState({
    orderNumber: '123456',
    items: [
      { name: 'Wanton', quantity: 2, price: 100 },
      { name: 'Ramen', quantity: 1, price: 50 },
    ],
    total: 250,
  });

  //billout
  const handleCheckoutModal = () => {
    setModalOpen(true); // Open the modal when "Bill out" is clicked
    //handleRefresh();
};

const handleCloseModal = () => {
    setModalOpen(false); // Close the modal
   // handleRefresh();
};

const openTableModal = () => {
  setIsTableModalOpen(true);
};

const closeTableModal = () => {
  setIsTableModalOpen(false);
  //handleRefresh();
};

  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [waitersRes, productsRes, openOrdersRes, categoryRes, vendorRes, cashierRes] = await Promise.all([
          axios.get(`${apiUrl}/api/users?role=waiter`),
          axios.get(`${apiUrl}/api/products`),
          axios.get(`${apiUrl}/api/carts/open`),
          axios.get(`${apiUrl}/api/product-categories`),
          axios.get(`${apiUrl}/api/vendors`),
          axios.get(`${apiUrl}/api/users?role=cashier`)
        ]);
  
        console.log('Products:', productsRes.data); // Add this to check products response
        
        setWaiters(waitersRes.data);
        setProducts(productsRes.data);
        setProductsToDisplay(productsRes.data);
        setOpenOrders(openOrdersRes.data);
        setCategories(categoryRes.data);
        setVendors(vendorRes.data);
        setCashiers(cashierRes.data);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
    fetchOpenTables();
  }, []);
  

  useEffect(() => {
    console.log('Cart items state updated:', cartItems);
    setOriginalCartItems(cartItems);
  }, [cartItems]);


  const fetchOpenTables = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/carts/open`);
      if (response.status === 200) {
        setOpenTables(response.data);
      } else {
        console.error('Failed to fetch open tables:', response.data);
      }

      
    } catch (error) {
      console.error('Error fetching open tables:', error);
    }
  };

  //verify pin of the waiter
  const verifyPin = async () => {
    try {
      const data = { waiter, waiterPin };
      console.log('Sending data:', data); // Log the data being sent
  
      const response = await axios.post(`${apiUrl}/api/users/verifyPin`, data);
      if (response.status === 200) {
        setIsPinVerified(true);
        alert('PIN verified successfully');
      } else {
        setIsPinVerified(false);
        alert('Invalid PIN. Please try again.');
      }
    } catch (error) {
      console.error('Error verifying PIN:', error);
      alert('Error verifying PIN. Please try again.');
    }
  };

  
  const handleAddToCart = (product) => {
    if (!quantity || quantity <= 0 || !isPinVerified) {
      console.log('Invalid quantity or PIN not verified');
      return;
    }
  
    const price = transactionType === 'grab' ? product.grabprice : product.price;
    const existingItem = cartItems.find(item => item.productId === product._id);
  
    if (existingItem) {
      // Update existing item
      const newQuantity = existingItem.quantity + quantity;
  
      setCartItems(prevItems =>
        prevItems.map(item =>
          item.productId === product._id
            ? { ...item, quantity: newQuantity, notes: existingItem.notes, isNew: false } // Retain notes, mark as not new
            : item
        )
      );
  
      // Track this item as updated
      setUpdatedItems(prev =>
        prev.includes(product._id) ? prev : [...prev, product._id]
      );
    } else {
      // Add new item
      const newItem = {
        productId: product._id,
        name: product.name,
        quantity,
        price,
        notes: notes, // Use the notes entered by the user
        isNew: true,
        printed: false, // Default to not printed
      };
  
      setCartItems(prevItems => [...prevItems, newItem]);
  
      // Track this item as newly added
      setUpdatedItems(prev =>
        prev.includes(product._id) ? prev : [...prev, product._id]
      );
    }
  
    setQuantity(1);
    setNotes(''); // Clear notes after adding to cart
  };
  
  
  
  
  // Monitor cart items state for debugging
useEffect(() => {
  console.log('Cart Items:', cartItems); // Debug: Check updated cart items
}, [cartItems]);

const handlePlaceOrder = async () => {
  if (!isPinVerified) {
    alert('Please verify the PIN before placing the order.');
    return;
  }

  console.log('Cart Items before placing order:', cartItems);

  if (!waiter || !tableNumber || !transactionType || cartItems.length === 0) {
    alert('Please fill in all fields and add at least one item to the cart.');
    return;
  }

  try {
    let response;

    // Update cart items to include printed flags and initialize printedQuantity if missing
    const updatedCartItems = cartItems.map(item => ({
      ...item,
      printed: updatedItems.includes(item.productId) ? true : item.printed, // Update printed status
      printedQuantity: item.quantity || 0, // Initialize printedQuantity to 0 if not set
    }));

    setCartItems(updatedCartItems); // Update state with prepared items

    console.log('Updated cartItems for placing order:', updatedCartItems);

    // Prepare order data
    const orderData = {
      waiter,
      tableNumber,
      transactionNumber,
      transactionType,
      items: updatedCartItems, // Use updated cart items
      billedOut: false,
    };

    // If updating an existing order, reset `isNew` and ensure consistency
    if (selectedOrder && selectedOrder._id) {
      setCartItems(prevItems =>
        prevItems.map(item => ({
          ...item,
          isNew: false, // Reset isNew flag
          printed: true, // Mark as printed
        }))
      );
      setNewItems([]); // Clear newly added items
    }

    console.log('Order Data to submit:', orderData);

    // Send order data to the backend
    if (selectedOrder && selectedOrder._id) {
      const existingOrderResponse = await axios.get(`${apiUrl}/api/carts/${selectedOrder._id}`);

      if (existingOrderResponse.status === 200 && existingOrderResponse.data) {
        response = await axios.put(`${apiUrl}/api/carts/${selectedOrder._id}`, orderData);
        console.log('Update response:', response.data);
      } else {
        response = await axios.post(`${apiUrl}/api/carts`, orderData);
        console.log('Create response:', response.data);
      }
    } else {
      response = await axios.post(`${apiUrl}/api/carts`, orderData);
      console.log('Create response:', response.data);
    }

    // Handle response
    if (response.status === 200 || response.status === 201) {
      alert('Order placed successfully');
      console.log(transactionNumber);
      handlePrintReceipt(); // Trigger receipt printing

      // Clear state after placing the order
      setSelectedOrder(null);
      setCartItems([]);
      setTableNumber('');
      setWaiter('');
      setTransactionType('');
      setTransactionNumber('');

      fetchOpenTables();
      handleRefresh();
    } else {
      alert('Failed to place order. Please try again.');
    }
  } catch (error) {
    console.error('Error placing order:', error.response?.data || error.message);
    alert('Failed to place order. Please try again.');
  } finally {
    setIsLoading(false); // Stop loading spinner
  }
};


  
  const handleSelectOrder = (order) => {

    console.log('Selected order', order);
    setSelectedOrder(order);
    console.log('Selected order', order.waiter);
    setWaiter(order.waiter);
    setTransactionNumber(order.transactionNumber);
    
    const updatedItems = (order.items || []).map(item => {
      const product = products.find(p => p._id === item.productId);  // Check if product is found
      
      console.log('Selected product', product); // Log found product
      
      return {
        ...item,
        name: product ? product.name : item.name || 'Unnamed Product',
      };
    });
  
    setCartItems(updatedItems);
    setTableNumber(order.tableNumber || '');
    setWaiter(order.waiter || '');
    setTransactionType(order.transactionType || '');
    //setTransactionNumber(order.transactionNumber || '');
  };
  
  

  
  


  const calculateTotal = () => {
    return cartItems.reduce((acc, item) => acc + (item.price * item.quantity), 0);
  };

  // Helper function to get category name by ID
const getCategoryName = (categoryId) => {
  const category = categories.find(c => c._id === categoryId);
  return category ? category.name : 'Unknown';
};


const handleSearch = (searchTerm) => {
  if (searchTerm.trim() === '') {
    setProductsToDisplay(products);
  } else {
    const filteredProducts = products.filter((product) => {
      const searchText = searchTerm.toLowerCase();
      return (
        product.name.toLowerCase().includes(searchText) ||
        product.category.toLowerCase().includes(searchText)
      );
    });
    setProductsToDisplay(filteredProducts);
  }
};

const handlePrintReceipt = async () => {
  if (!cartItems || cartItems.length === 0) {
    alert('Cart is empty or missing items.');
    console.error('No cart items found');
    return;
  }

  console.log('Current cartItems:', cartItems);

  // Filter items for printing: focus on new or updated quantities
  const filteredCartItems = cartItems
    .map(item => {
      // Calculate the quantity to print
      const alreadyPrintedQuantity = item.printedQuantity || 0; // Use printedQuantity or default to 0
      const newQuantity = item.quantity - alreadyPrintedQuantity;

      if (newQuantity > 0) {
        return { ...item, quantity: newQuantity }; // Only include the new quantity
      }
      return null; // Exclude items with no new quantity
    })
    .filter(item => item !== null);

  console.log('Filtered cartItems to print:', filteredCartItems);

  if (filteredCartItems.length === 0) {
    alert('No items to print.');
    return;
  }

  // Prepare receipt data for printing
  const receiptData = {
    waiter,
    tableNumber,
    transactionNumber,
    transactionType,
    cartItems: filteredCartItems,
    total: calculateTotal(filteredCartItems), // Calculate total for printed items only
  };

  console.log('Receipt data:', receiptData);

  try {
    // Send data to the backend for printing
    const response = await axios.post(`${apiUrl}/api/print-receipt`, receiptData, {
      headers: { 'Content-Type': 'application/json' },
    });

    console.log('Response from server:', response.data);

    // Update cart items: Mark printed items as "printed" and track printed quantity
    const updatedCart = cartItems.map(item => {
      const filteredItem = filteredCartItems.find(filtered => filtered.productId === item.productId);
      if (filteredItem) {
        return {
          ...item,
          printed: true,
          printedQuantity: (item.printedQuantity || 0) + filteredItem.quantity, // Update printedQuantity
        };
      }
      return item;
    });

    setCartItems(updatedCart); // Update cartItems state
    setUpdatedItems([]); // Clear updated items tracking

    alert('Receipt printed successfully!');
  } catch (error) {
    console.error('Error printing receipt:', error.response ? error.response.data : error.message);
    alert('Failed to print receipt. Please try again.');
  }
};




const handleNotesChange = (productId, newNotes) => {
  setNotes(prevNotes => ({
    ...prevNotes,
    [productId]: newNotes // Store notes for specific productId
  }));

  // Update the cart items if they are already added
  setCartItems(prevItems =>
    prevItems.map(item =>
      item.productId === productId
        ? { ...item, notes: newNotes } // Update notes in cart items
        : item
    )
  );
};


const handleRefresh = () => {
    setSelectedOrder(null);
    setCartItems([]);
    setTableNumber('');
    setWaiter('');
    setTransactionType('');
    setTransactionNumber('');
    setWaiterPin('');

    fetchOpenTables();
};

const handleEditCartItem = (productId, newQuantity) => {
  if (newQuantity <= 0) {
    // If the new quantity is less than or equal to 0, remove the item from the cart
    setCartItems(prevItems => prevItems.filter(item => item.productId !== productId));
  } else {
    // Update the quantity of the item
    setCartItems(prevItems =>
      prevItems.map(item =>
        item.productId === productId
          ? { ...item, quantity: newQuantity }
          : item
      )
    );
  }
};

const handleDeleteCartItem = ( productId) => {
  

  const confirmed = window.confirm('Are you sure you want to remove this item?');
  if (confirmed) {

    const updatedItems = cartItems.filter(item => item.productId !== productId);
    console.log('updatedItems.cartId',  selectedOrder._id);
    cancelPrintedItem( selectedOrder._id, productId);

    setCartItems(updatedItems);
    
    //setCartItems(updatedItems);

    //setCartItems(prevItems => prevItems.filter(item => item.productId !== productId));
  }
};


async function cancelPrintedItem(cartId, productId) {
  try {
    const response = await axios.post(`${apiUrl}/api/carts/cancel-printed-item`, {
      cartId,
      productId
    });

    if (response.status === 200) {
      alert(response.data.message);
    } else {
      alert('Failed to cancel printed item: ' + response.data.error);
    }
  } catch (error) {
    console.error('Error canceling printed item:', error);
    alert('An error occurred. Please try again.');
  }
}


const handleVoidTransaction = async () => {
  const adminPassword = prompt('Enter Admin Password to Void Transaction:');

  if (adminPassword === 'admin123') { // Replace with actual password logic
    try {
      await axios.delete(`${apiUrl}/api/carts/${selectedOrder._id}`);
      alert('Transaction voided successfully.');
      fetchOpenTables(); // Refresh open tables
      setSelectedOrder(null);
      setCartItems([]);
    } catch (error) {
      console.error('Error voiding transaction:', error);
      alert('Failed to void transaction.');
    }
  } else {
    alert('Invalid admin password.');
  }
};




const handleCheckout = async () => {
  try {
    if (!selectedOrder?._id) {
      alert('No order selected for checkout');
      return;
    }

    if (!selectedOrder?._id) {
      alert('No order selected for checkout');
      return;
    }
      // Update the selected order with billedOut status
    const updatedOrder = {
      ...selectedOrder,
      billedOut: true
    };


    // Log the updated order data before making the API call
    console.log('Updating order for checkout:', updatedOrder);

    const response = await axios.put(`${apiUrl}/api/carts/checkout/${selectedOrder._id}`, updatedOrder);

    if (response.status === 200) {
      alert('Billout completed, table cleared.');
      setSelectedOrder(null); // Reset selectedOrder to null
      setCartItems([]);
      setSelectedOrder(null);
      setTableNumber('');
      setWaiter('');
      setTransactionType('');
      setTransactionNumber('');

      fetchOpenTables(); // Refresh the list of open tables
    } else {
      alert('Failed to billout table.');
    }
  } catch (error) {
    console.error('Error during billout:', error);
    alert('Failed to complete billout.');
  }
};

const handleBillingComplete = async () => {
  try {
    if (!selectedOrder?._id) {
      alert('No order selected to update.');
      return;
    }

    // Update the selected order with the billing completed status
    const updatedOrder = {
      ...selectedOrder,
      billedOut: true, // Assuming this is the status you want to set
    };

    // Log the updated order data before making the API call
    console.log('Updating order after billing:', updatedOrder);

    const response = await axios.put(`${apiUrl}/api/carts/checkout/${selectedOrder._id}`, updatedOrder);

    if (response.status === 200) {
      alert('Billing completed, order updated successfully.');
      
      // Reset state variables
      setSelectedOrder(null); // Reset selectedOrder to null
      setCartItems([]);
      setTableNumber('');
      setWaiter('');
      setTransactionType('');
      setTransactionNumber('');
      setWaiterPin('');

      fetchOpenTables(); // Refresh the list of open tables
    } else {
      alert('Failed to update the order after billing.');
    }
  } catch (error) {
    console.error('Error during billing update:', error);
    alert('Failed to complete billing update.');
  }
};



const handleSelectTable = (table) => {

  console.log('handleSelectTable triggered with table:', table);
  setSelectedOrder(table);
  setCartItems(table.items || []);
  setTableNumber(table.tableNumber);
};



 // Fetch available tables from the API
 const fetchTables = async () => {
  try {
    const response = await axios.get(`${apiUrl}/api/tables`);
    const sortedTables = response.data.sort((a, b) => a.tableNumber - b.tableNumber); // Sort tables by table number
    setTables(sortedTables.filter(table => table.status == "available")); // Only keep available tables
  } catch (error) {
    console.error('Error fetching tables:', error);
  }
};


  // Fetch tables only if transaction type is dinein or takeout
  useEffect(() => {
    if (transactionType === 'dinein' || transactionType === 'takeout') {
      fetchTables();
    } else {
      setTableNumber(''); // Clear table number if transaction type is not dinein or takeout
    }
  }, [transactionType]);

  const handleTransactionTypeChange = (e) => {
    setTransactionType(e.target.value);
    setTableNumber(''); // Reset table selection if transaction type changes
  };




  return (
    <div className="container mx-auto p-4 flex">
      {/* Left Side */}
      <div className="w-3/4 p-4">
        <div className='container justify-between flex pb-8 '>
          <h1 className="text-2xl font-bold mb-4">Order</h1>
          <div>

          <button onClick={handleRefresh} className="bg-green-500 text-white hover:bg-green-400 hover:text-white px-4 py-2 mt-2 w-400 mr-5">
              NEW ORDER
            </button>
            <button onClick={handleRefresh} className="outline text-green-600 hover:bg-green-500 hover:text-white px-4 py-2 mt-2 w-400">
              REFRESH
            </button>
          </div>
        </div>

        <hr/>

       
        <div className='container mx-auto flex'>
        <select
          value={waiter}
          onChange={e => setWaiter(e.target.value)}
          className="border p-2 mb-2 mr-2 w-1/2"
        >
          <option value="">Select Waiter</option>
          {waiters.map(w => (
            <option key={w._id} value={w.name}>{w.name}</option>
          ))}
        </select>
        <input
          type="password"
          value={waiterPin}
          onChange={e => setWaiterPin(e.target.value)}
          placeholder="Waiter PIN"
          className="border p-2 mb-2 w-1/3"
        />

        <button
          onClick={verifyPin}
          className="bg-teal-500 text-white px-4 py-2 mb-2"
        >
          Verify PIN
        </button>
        </div>

        <div className='container mx-auto flex'>
        <p className="p-2 text-md font-normal mb-4">Transaction Type:</p>
        <select value={transactionType} onChange={handleTransactionTypeChange} className="border p-2 mb-2 w-1/2">
          <option value="">Select Transaction Type</option>
          <option value="dinein">Dine-in</option>
          <option value="takeout">Take-out</option>
          <option value="grab">GRAB</option>
        </select>
        </div>

        <div className='container mx-auto flex'>

          <p className="p-2 text-md font-normal mb-4">Table Number:</p>
       
          {isPinVerified ? (
            (transactionType === 'dinein' ) ? (
              <select
                value={tableNumber}
                onChange={e => setTableNumber(e.target.value)}
                className="border p-2 mb-2 w-auto"
              >
                <option value="">Select Available Table</option>
                {tables.map(table => (
                  <option key={table._id} value={table.tableNumber}>
                    Table {table.tableNumber}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                value={tableNumber}
                onChange={e => setTableNumber(e.target.value)}
                placeholder="Table Number or Reference number"
                className="border p-2 mb-2 w-1/2"
                disabled={!isPinVerified} 
              />
            )
          ) : null}


    
        
        </div>

       

        

        <div className="mt-4">
          <h2 className="text-xl font-bold mb-4">Search Products</h2>
          <input
            type="text"
            placeholder="Search Products"
            className="border p-2 mb-2  w-1/2"
            onChange={(e) => handleSearch(e.target.value)}
          />
          <div className="grid grid-cols-3 gap-4">
            {/* Rest of your product display code */}
          </div>
        </div>

        <div className="mt-4">
          <h2 className="text-xl font-bold mb-4">Products</h2>
          <div className="grid grid-cols-3 gap-4">
          {productsToDisplay.map(p => (
              <div key={p._id} className="border p-4 rounded shadow-lg">
                <h3 className="text-lg font-bold mb-2">{p.name}</h3>
                <p><strong>Price:</strong> {transactionType === 'grab' ? p.grabprice?.toFixed(2) : p.price?.toFixed(2)}</p>
                <button onClick={() => handleAddToCart(p)} className="bg-green-500 text-white px-4 py-2">Add to Cart</button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right Side */}
      <div className="w-1/4 p-4 bg-gray-200 h-screen">
        <div className="flex justify-between mb-4">
          <h2 className="text-xl font-bold">Cart</h2>
          <button
            onClick={() => setSidebarVisible(!sidebarVisible)}
            className="text-blue-500"
          >
            {sidebarVisible ? 'Hide' : 'Show'} Open Orders
          </button>
        </div>
        {sidebarVisible && (
          <div className="bg-white p-4 shadow-lg mb-4">
            <h3 className="text-lg font-bold mb-2">Open Orders</h3>
            {openTables.map(order => (
              <div key={order._id} className="border p-2 mb-2">
              <p><strong>Transaction number:</strong> {order.transactionNumber}</p>
                <p><strong>Table:</strong> {order.tableNumber}</p>
                <p><strong>Waiter:</strong> {order.waiter}</p>
                <button
                  onClick={() => handleSelectOrder(order)}
                  className="bg-teal-500 text-white px-2 py-1 rounded"
                >
                  Select Order
                </button>
              </div>
            ))}
          </div>
        )}
        <h2>Table Number: {tableNumber} </h2>
        <h2>Waiter: {waiter} </h2>
        <h2>Transaction number: {transactionNumber} </h2>
        <h3 className='text-medium'>Ordered Items:</h3>

        {cartItems.length > 0 ? (
            cartItems.map(item => (
              <div className='p-2 bg-slate-100 flex  justify-between mb-2 rounded-md'>
              <div key={item.productId} className='text-balance '>
                  <div className='pb-2'>{item.name} ({item.price}) <br/>
                  </div>
                  <div className='flex'>
                    <span className='p-2'>{item.quantity}</span> 
                </div>
                <input
                  type="text"
                  value={item.notes}
                  placeholder="Add notes"
                  onChange={e => handleNotesChange(item.productId, e.target.value)}
                  className="border p-1 mb-2 w-full"
                />
                </div>
                <div className='pb-4 mb-5 text-right'>
                  <div>{item.quantity * item.price}</div>
                 
                  <div>
                    <button className='button p-2 mb-3 bg-red-500 text-white' onClick={() => handleDeleteCartItem(item.productId)}>DELETE</button>
                  </div>
                  <div>
                    <button className='button p-2 bg-slate-500 text-white' onClick={() => handleProductTransfer(selectedOrder._id, item.productId)}>Transfer</button>
                  </div>
                </div>
                
              </div>
                
            ))
        ) : (
          <p>
            <em>No items found. Please select a table.</em>
          </p>
        )}
        
        

        <div className="mt-4">
          <div className='flex justify-between'>
            <p>
            <strong>Total:</strong> 
            </p>
            <p>{calculateTotal().toFixed(2)}</p>
          </div>
          <button
            onClick={handlePlaceOrder}
            className="bg-teal-500 text-white px-4 py-2 mt-2 w-full"
          >
            Place Order
          </button>
          <button
                onClick={handleCheckoutModal}
                className="bg-orange-500 text-white px-4 py-2 mt-2 w-full"
            >
                Bill out
            </button>

           {/* Billing Modal */}
           <BillingModal isOpen={isModalOpen} onClose={handleCloseModal} cartItems={cartItems} 
                cashiers={cashiers} waiter={waiter} tableNumber={tableNumber} transactionNumber={transactionNumber}  apiUrl={apiUrl} 
                handleBillingComplete={handleBillingComplete} />

          {/* Modal component */}
          {showItemTransferModal && 
                  <ItemTransferModal 
                    productId={selectedProduct} 
                    sourceCartId={selectedSourceCartId} 
                    onClose={handleCloseProductTransfer}
                    isOpen={showItemTransferModal}
                  />
                }

            <div>
              {/* Button to open the Table Management Modal */}
                <button onClick={openTableModal} className="bg-green-500 text-white px-4 py-2 mt-2 w-full">
                  Manage Tables
                </button>

                {/* Table Management Modal */}
                {isTableModalOpen && (
                  <TableManagementModal apiUrl={apiUrl}  onClose={closeTableModal} />
                )}
            </div>


            <button onClick={handleRefresh} className="outline text-blue px-4 py-2 mt-2 w-full">
              NEW ORDER
            </button>
        
        </div>
      </div>
    </div>
  );
};

export default OrderingPage;
